import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import {
  Heading,
  Modal,
  ProgressCircle,
  Text,
  Button,
  IconCompleteSolid,
  IconWarningSolid,
} from "@instructure/ui";
import { t } from "i18next";

export const Progress = ({
  label,
  modalOpen,
  currentProgress,
  totalItems,
  item,
  showErrorMessage,
  setModalOpen,
  loadingTriggered,
  setLoadingTriggered,
  setParentProg,
  setTotalOutcomes,
  setShowErrorMessage,
  success,
  successText,
  errorText,
}) => {
  const [prog, setProg] = useState(null);

  useEffect(() => {
    setProg(currentProgress);
  }, [currentProgress]);

  const handleClose = () => {
    setModalOpen(false);
    setShowErrorMessage(false);
    setParentProg(0);
    setTotalOutcomes(0);
  };

  const handleRetry = () => {
    handleClose();
    setLoadingTriggered(true);
  };

  return !showErrorMessage && modalOpen ? (
    success ? (
      <Modal open={modalOpen} label={t("progress.updateSuccess")}>
        <Modal.Body>
          <div style={{ textAlign: "center" }}>
            <div style={{ marginBottom: 10 }}>
              <IconCompleteSolid color="success" size="medium" />
            </div>
            <Text size="medium" as="p" weight="bold" color="primary">
              {successText}
            </Text>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button margin="0 small 0 0" onClick={handleClose}>
            {t("global.close")}
          </Button>
        </Modal.Footer>
      </Modal>
    ) : modalOpen ? (
      <Modal open={modalOpen} label={t("progress.dataLoading")}>
        <Modal.Body>
          <div style={{ textAlign: "center" }}>
            <Heading as="h3">{label}</Heading>
            <ProgressCircle
              screenReaderLabel={t("progress.percentComplete")}
              formatScreenReaderValue={({ valueNow, valueMax }) => {
                return Math.floor((valueNow / valueMax) * 100) + " percent";
              }}
              renderValue={({ valueNow, valueMax }) => {
                const percent = Math.floor((valueNow / valueMax) * 100);
                return (
                  <span>
                    <Text size="large" weight="bold" color="primary">
                      {percent > 100 ? 100 : percent}
                    </Text>
                    <Text size="small" weight="bold" color="secondary">
                      %
                    </Text>
                  </span>
                );
              }}
              valueMax={totalItems}
              valueNow={prog || 0}
            />
            <Text size="large" as="p" weight="bold" color="primary">
              {t("progress.loadingUpdates")}
            </Text>
            <Text size="small" weight="bold" color="secondary">
              {t("progress.currentProgress")} {prog} {t("progress.outOf")}{" "}
              {totalItems} {item}
            </Text>
          </div>
        </Modal.Body>
      </Modal>
    ) : null
  ) : !showErrorMessage && loadingTriggered ? (
    <Skeleton
      count={1}
      style={{ height: 64, borderRadius: 5, marginTop: 10 }}
    />
  ) : modalOpen ? (
    <Modal open={modalOpen} label={t("progress.updateFail")}>
      <Modal.Body>
        <div style={{ textAlign: "center" }}>
          <div style={{ marginBottom: 10 }}>
            <IconWarningSolid color="error" size="medium" />
          </div>
          <div style={{ padding: "10px" }}>
            <Text size="large" as="p" weight="bold" color="primary">
              {errorText}
            </Text>
          </div>
          <div style={{ padding: "10px" }}>
            <Text size="medium" weight="bold" color="secondary">
              {t("progress.managedToUpdate")} {prog} {t("progress.outOf")}{" "}
              {totalItems} {item}
            </Text>
          </div>
          <div style={{ padding: "10px" }}>
            <Text size="medium" weight="bold" color="secondary">
              {t("progress.attemptOrCancel")}
            </Text>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button margin="0 small 0 0" onClick={handleClose}>
          {t("global.continue")}
        </Button>

        <Button color="primary" onClick={handleRetry}>
          {t("progress.tryAgain")}
        </Button>
      </Modal.Footer>
    </Modal>
  ) : null;
};
